











































import Vue, { PropType } from "vue"
import { BannerView } from "~/clApi/viewModel/ad"
import { ImageView } from "~/backendApis/viewModel"

export default Vue.extend({
  props: {
    bannerList: {
      type: Array as PropType<BannerView[]>,
      required: true,
    },
  },
  data() {
    return {
      model: 0,
    }
  },
  methods: {
    handleClickLink(name?: string) {
      this.$gtag("event", "click_banner", {
        banner_name: name ?? "no_name",
      })
    },
    isExternal(url: string) {
      return !url.startsWith(
        process.env.SERVICE_BASE_URL ?? "https://crowdlinks.jp"
      )
    },
    getPath(url: string) {
      const urlObj = new URL(url)
      return urlObj.pathname
    },
    getImageUrl(image: ImageView) {
      return this.$clHelpers.thumbnail.generateURL({
        image,
        width: 600,
        height: 200,
      })
    },
  },
})
